<template>
    <label
        class="cursor"
        @click.prevent="filterBy(filterItem)"
    >
        <input
            type="checkbox"
            :value="filterItem.id"
        />
        {{ filterItem.id }}
    </label>
</template>

<script>
    export default {
        name: "BadgeItem",
        props: {
            filterItem: {
                type: Object,
                required: true,
            }
        },
        methods: {
            filterBy(filter) {
                this.$emit('filter-method', filter);
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/sidebar/cutaway/components/BadgeItem.vue